<template>
  <div class="con-wrap">
    <div class="top">
      <el-button type="primary" @click="goback">返回</el-button>
      <el-button type="primary" @click="transferOrder">确认转单</el-button>
    </div>
    <div class="con-wrap-inner">
      <el-aside width="300px" style="height: auto">
        <el-row class="title" :gutter="20">
          <el-col :span="16">
            <div class="grid-content bg-purple">工单信息</div>
          </el-col>
        </el-row>
        <div class="info-box">
          <el-row :gutter="20">
            <el-col :span="6" class="order-label">区域</el-col>
            <el-col :span="18" class="order-con">{{
              infoData.areaName
            }}</el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6" class="order-label">站址名称</el-col>
            <el-col :span="18" class="order-con">{{
              infoData.stationName
            }}</el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6" class="order-label">工单编号</el-col>
            <el-col :span="18" class="order-con">{{
              infoData.subjectNum
            }}</el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6" class="order-label">工单类型</el-col>
            <el-col :span="18" class="order-con">{{ infoData.type }}</el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6" class="order-label">工单状态</el-col>
            <el-col :span="18" class="order-con">{{
              infoData.receiveState
            }}</el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6" class="order-label">工单内容</el-col>
            <el-col
              :span="18"
              :title="infoData.errorContent"
              class="order-con text-overflow"
              >{{ infoData.errorContent }}</el-col
            >
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6" class="order-label">派单人员</el-col>
            <el-col :span="18" class="order-con">{{
              infoData.dispatchName
            }}</el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6" class="order-label">接单人员</el-col>
            <el-col
              :span="18"
              :title="infoData.receiveName"
              class="order-con text-overflow"
              >{{ infoData.receiveName }}</el-col
            >
          </el-row>
        </div>
      </el-aside>
      <el-container
        class="map-wrap"
        style="flex-direction: column; width: 100%"
      >
        <el-row class="title" :gutter="20">
          <el-col :span="16">
            <div class="grid-content bg-purple">选择接转单人员</div>
          </el-col>
        </el-row>
        <div class="group-box">
          <div class="user-box">
            <div v-for="item in userList" :key="item.personnelId">
              <p class="user-title">{{ item.name }}</p>
              <el-radio-group v-model="selectForm" @input="overrun">
                <el-radio-button
                  v-for="data in item.personnelOptions"
                  :label="data.personnelId"
                  :key="data.personnelId"
                  @click.native="btnClicked"
                  >{{ data.name }}
                  <p>{{ data.plate }}</p></el-radio-button
                >
              </el-radio-group>
            </div>
          </div>
          <div id="map-box"></div>
        </div>
      </el-container>
    </div>
  </div>
</template>

<script>
import AMap from "AMap";
export default {
  data() {
    return {
      id: "",
      //添加地图需求
      map: null,
      scale: null,
      vehicleLocal: [],
      infoWindow: null,
      vehicleMarker: [],
      stationMarker: [],
      infoData: {},
      userList: [],
      selectForm: "",
    };
  },
  watch: {
    selectForm(newValue) {
      // 选中转单人员，车辆高亮显示
      // 找到对应的车辆，将车辆图标替换
      this.vehicleLocal.forEach((item) => {
        if (newValue == item.id) {
          item.icon = true;
        } else {
          item.icon = false;
        }
      });
      this.addVehicleMarker();
    },
  },
  created: function() {
    this.id = this.$route.params.id;
    this.getOrderInfo();
    this.getVehicleLocation();
  },
  mounted() {
    this.init();
  },
  methods: {
    btnClicked(e) {
      if (e.target.tagName === "INPUT") {
        if (this.selectForm === "") {
          // 选中状态
          this.selectForm = "1";
        } else {
          // 取消选中
          this.selectForm = "";
          // this.addVehicleMarker(true);
        }
      }
    },
    overrun(newValue) {
      let childrenList = [];
      this.userList.forEach((item) => {
        childrenList.push(...item.personnelOptions);
      });
      let childrenOne = childrenList.filter((items) => {
        return items.personnelId === newValue;
      });
      let childrenObj = childrenOne[0];
      if (childrenObj && childrenObj.status == 2) {
        this.$confirm(
          "该车辆保养里程已超限，无法开启发电功能，是否继续转单？",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            this.$message({
              type: "success",
              message: "继续转单!",
            });
          })
          .catch(() => {
            this.selectForm = "";
            this.$message({
              type: "info",
              message: "已取消继续转单",
            });
          });
      }
    },
    init() {
      this.map = new AMap.Map("map-box", {
        center: [116.397428, 39.90923],
        resizeEnable: true,
        zoom: 12,
        mapStyle: "amap://styles/fresh",
      });
      this.geocoder = new AMap.Geocoder({
        city: "010", //城市设为北京，默认：“全国”
        radius: 1000, //范围，默认：500
      });

      // scale 比例尺
      AMap.plugin(["AMap.Scale"], () => {
        this.scale = new AMap.Scale({
          visible: true,
        });
        this.map.addControl(this.scale);
      });

      //this.infoWindow = new AMap.InfoWindow({ offset: new AMap.Pixel(0, -30) })
      this.infoWindow = new AMap.InfoWindow();
    },
    goback() {
      this.$router.push("/Dispatch");
    },
    async getOrderInfo() {
      let _this = this;
      //显示弹框
      let { data: res } = await _this.$axios.get(
        "/api/v2/order/manage/transfer/stattion/" + _this.id
      );
      if (res.code == 1) {
        _this.infoData = res.data;
        _this.getUserList(res.data.areaId);
        _this.addStationMarker(res.data);

        if (_this.infoData.receiveState == "1") {
          _this.infoData.receiveState = "待接单";
        } else if (_this.infoData.receiveState == "2") {
          _this.infoData.receiveState = "已接单";
        } else if (_this.infoData.receiveState == "3") {
          _this.infoData.receiveState = "已回单";
        } else if (_this.infoData.receiveState == "4") {
          _this.infoData.receiveState = "转单中";
        }
        _this.infoData.type =
          _this.infoData.type == 1 ? "计划发电" : "应急发电";
      } else {
        _this.$message.warning(res.msg);
      }
    },
    async getUserList(areaId) {
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/maintain/dept/options/group?areaId=" + areaId
      );
      if (res.code == 1) {
        _this.userList = res.data;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    //获取车辆定位信息
    async getVehicleLocation() {
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/order/manage/vehicle/gps"
      );
      if (res.code == 1) {
        _this.vehicleLocal = res.data;
        _this.addVehicleMarker();
      } else {
        _this.$message.warning(res.msg);
      }
    },
    //添加车辆标记
    addVehicleMarker() {
      let _this = this;
      let data = this.vehicleLocal;
      if (_this.vehicleMarker.length) {
        _this.map.remove(_this.vehicleMarker);
      }
      let marker = "";
      let myIcon = "";
      let vehicleMarker = [];
      for (var i = 0; i < data.length; i++) {
        // 找出选中车辆，改变图标
        if (data[i].icon) {
          myIcon = new AMap.Icon({
            image: require("@/assets/images/car-online-active.png"),
            imageSize: new AMap.Size(36, 36),
            size: [36, 36],
            offset: new AMap.Pixel(-14, 0),
            // // 图标取图偏移量
            // imageOffset: new AMap.Pixel(0, -4),
          });
          // let locationArr = data[i].lnglat || marker.getPosition();
          // _this.infoWindow.setContent(
          //   data[i].groupName + "：<br/>" + data[i].personnelName
          // );
          // if (!a) {
          //   _this.infoWindow.open(_this.map, locationArr);
          // } else {
          //   _this.infoWindow.close();
          // }
        } else {
          myIcon = new AMap.Icon({
            image: require("@/assets/images/car-online.png"),
            imageSize: new AMap.Size(36, 36),
            size: [36, 36],
            // 图标取图偏移量
            // imageOffset: new AMap.Pixel(0, 0),
          });
          // _this.infoWindow.close()
        }
        marker = new AMap.Marker({
          position: data[i].lnglat,
          icon: myIcon,
          size: new AMap.Size(20, 30),
          map: _this.map,
          offset: new AMap.Pixel(-14, 0),
        });
        if (data[i].icon) {
          marker.setTop(true);
          marker.setLabel({
            direction: "center",
            offset: new AMap.Pixel(0, -52), //设置文本标注偏移量
            content: `<div class='info'>${data[i].groupName +
              "：<br/>" +
              data[i].personnelName}</div>`, //设置文本标注内容
          });
          // 打开label时将车辆窗体关闭
          if (_this.infoWindow.getIsOpen()) {
            _this.infoWindow.close();
          }
        } else {
          marker.setTop(false);
          marker.setLabel({
            direction: "center",
            offset: new AMap.Pixel(0, -52), //设置文本标注偏移量
            content: `<div class='hide_info'>${data[i].groupName +
              "：<br/>" +
              data[i].personnelName}</div>`, //设置文本标注内容
          });
        }
        vehicleMarker.push(marker);
        marker.content = data[i];
        AMap.event.addListener(marker, "click", function(e) {
          // // 点击车辆发现选中运维列表中已经有该点击车俩，需要取消选中
          // if (_this.selectForm == e.target.content.id) {
          //   // _this.infoWindow.close();
          //   // _this.selectForm = "";
          //   // 找到该数组中的要删除元素位置
          //   // e.target.content.icon = false;
          //   marker.setTop(false);
          // } else {
          // 如果未选中运维人员，点击标记点时左边同时选中运维人员【将点击】
          // _this.selectForm = e.target.content.id;
          // e.target.content.icon = true;
          if (!(_this.selectForm == e.target.content.id)) {
            marker.setTop(true);
            _this.infoWindow.setContent(
              e.target.content.groupName +
                "：<br/>" +
                e.target.content.personnelName
            );
            _this.infoWindow.open(_this.map, e.target.content.lnglat);
          }
        });
      }
      _this.vehicleMarker = vehicleMarker;
      _this.$nextTick(() => {
        // 更改地图中心点
        _this.map.add(_this.vehicleMarker);
        _this.map.setZoom(12);
        //依据第一个坐标位置设置中心点
        //_this.map.setCenter(data[0].lnglat)
        //适应所有坐标点合适视野居中
        _this.map.setFitView();
      });
    },
    //添加基站标记
    addStationMarker(data) {
      let _this = this;
      if (_this.stationMarker.length) {
        _this.map.remove(_this.stationMarker);
      }
      let marker = "";
      marker = new AMap.Marker({
        position: data.location,
        icon: require("@/assets/images/base-station.png"),
        size: new AMap.Size(20, 30),
        map: _this.map,
        offset: new AMap.Pixel(-12, 0),
      });
      _this.stationMarker.push(marker);
      marker.content = data.stationName;
      AMap.event.addListener(marker, "click", function() {
        _this.infoWindow.setContent(marker.content);
        _this.infoWindow.open(_this.map, marker.getPosition());
      });
      //默认打开一个基站信息框
      // _this.stationMarker.emit("click", { target: marker })
      _this.$nextTick(() => {
        // 更改地图中心点
        _this.map.add(_this.stationMarker);
        _this.map.setZoom(10);
        //依据第一个坐标位置设置中心点
        //_this.map.setCenter(data[0].lnglat)
        //适应所有坐标点合适视野居中
        _this.map.setFitView();
      });
    },
    //转单
    async transferOrder() {
      console.log(this.selectForm);
      let _this = this;
      let parm = {};
      parm = {
        personnelId: _this.selectForm,
        subjectId: _this.id,
      };
      let { data: res } = await _this.$axios.post(
        "/api/v2/order/manage/transfer",
        parm
      );
      if (res.code == 1) {
        _this.selectForm = "";
        _this.map.remove(_this.stationMarker);
        _this.infoWindow.close();
        _this.$message.success("操作成功");
        _this.goback();
      } else {
        _this.$message.warning(res.msg);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .amap-marker-label {
  border: 0;
  padding: 0;
  border-radius: 6px;
  font-size: 14px;
  color: #333;
  line-height: 20px;
  border: 1px solid #ccc;
  .info {
    /*正常标签样式*/
    position: relative;
    top: 0;
    right: 0;
    min-width: 0;
    padding: 10px 25px;
  }
  .info::before {
    position: absolute;
    left: 50%;
    top: 100%;
    margin-left: -8px;
    margin-top: 1px;
    content: "";
    border-top: 8px solid #fff;
    border-bottom: 8px solid transparent;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    z-index: -1;
  }
  .info::after {
    position: absolute;
    content: "";
    left: 50%;
    top: 114%;
    margin-left: -8px;
    margin-top: -7px;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid rgba(0, 0, 0, 0.3);
    filter: blur(2px);
    z-index: -2;
  }

  .hide_info {
    /*隐藏标签样式*/
    display: none !important;
  }
}
::v-deep .el-radio-button:focus:not(.is-focus):not(:active):not(.is-disabled) {
  box-shadow: none;
}
.map-wrap .title {
  margin-bottom: 0 !important;
}
.top {
  height: 48px;
  line-height: 48px;
  display: block;
  margin-bottom: 20px;
  padding-left: 20px;
  background-color: #fff;
}
.con-wrap-inner {
  width: 100%;
  height: calc(100% - 68px);
  display: flex;
  flex-direction: row;
  background-color: #f8f8f8;
  .el-container {
    background-color: #fff;
  }
  .info-box /deep/ {
    padding: 0 16px;
    .el-row {
      line-height: 32px;
      font-size: 14px;
      color: #333;
    }
  }
  .order-label {
    font-weight: bold;
  }
}
.user-box {
  display: inline-block;
  width: 262px;
  height: 100%;
  overflow: auto;
}
.user-title {
  height: 26px;
  line-height: 26px;
  margin-left: 20px;
  padding-left: 10px;
  border-left: 3px solid #0093ff;
  font-weight: bold;
}
.user-box /deep/ .el-radio-group {
  width: 100%;
  height: 100%;
  margin-bottom: 20px;
  padding: 0 20px;
  box-sizing: border-box;
}
.user-box /deep/ .el-radio-button__orig-radio {
  left: 0;
}
.user-box /deep/ .el-radio-button__inner {
  width: 100%;
  height: 100%;
  float: left;
  line-height: 26px;
  padding: 0;
  box-sizing: initial;
  border: 0;
}
.user-box /deep/ .el-radio-button:first-child .el-radio-button__inner {
  border: 0;
}
.user-box /deep/ .el-radio-button.is-checked .el-radio-button__inner {
  background: #0094ff;
  color: #fff;
  border-color: #0094ff;
}
.user-box /deep/ .el-radio-button {
  width: 88px;
  height: 44px;
  overflow: hidden;
  line-height: 30px;
  margin: 6px;
  text-align: center;
  font-size: 14px;
  color: #333;
  border: 1px solid #ccc;
  border-radius: 4px;
  p {
    line-height: 14px;
    font-size: 12px;
    text-align: center;
  }
}
//地图
#map-box {
  display: inline-block;
  width: calc(100% - 262px);
  height: 100%;
}
.group-box {
  width: 100%;
  height: calc(100% - 42px);
  flex-direction: row;
  display: flex;
  box-sizing: border-box;
  overflow: hidden;
}
.show-station {
  width: 100px;
  margin: 0 0 10px 20px;
}
#map-box /deep/ .amap-info-content {
  padding: 10px 25px;
  border: 1px solid #ccc;
  border-radius: 6px;
  line-height: 20px;
  font-size: 14px;
  color: #333;
}
</style>
